import { useTranslation } from 'react-i18next';
import { portalLanguage } from '../i18n';

/** The badge artwork per language (client/public/aperio/), with its size. */
const BADGES: Record<string, { file: string; width: number }> = {
  en: { file: 'add-to-google-wallet-en.svg', width: 212 },
  fr: { file: 'add-to-google-wallet-fr.svg', width: 236 },
  es: { file: 'add-to-google-wallet-es.svg', width: 238 },
};

interface AddToGoogleWalletProps {
  /** The server's Save link (GET /api/wallet/google/:token). */
  href: string;
  /** Says which card it is, when there are several (Account → Cars). */
  describedBy?: string;
}

/**
 * The "Add to Google Wallet" badge (Aperio preset only: the confirmation
 * page and Account → Cars). Google's wording, Google's badge layout, in the
 * language on screen; it brings no stylesheet of its own (the `apr-wallet*`
 * hooks are styled in public/aperio/theme.css), so Go Oil's CSS bundle does
 * not change.
 */
export default function AddToGoogleWallet({
  href,
  describedBy,
}: AddToGoogleWalletProps) {
  const { t } = useTranslation();
  const badge = BADGES[portalLanguage()] || BADGES.en;
  return (
    <a
      className="apr-wallet__badge"
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      aria-describedby={describedBy}
      data-testid="add-to-google-wallet"
    >
      <img
        src={`/aperio/${badge.file}`}
        width={badge.width}
        height={48}
        alt={`${t('wallet.add')} ${t('confirm.calendar.newTab')}`}
      />
    </a>
  );
}
